class Elementor_ContactForm{
    static instance;

    static getInstance() {
        if (!Elementor_ContactForm.instance) {
            Elementor_ContactForm.instance = new Elementor_ContactForm();
        }
        return Elementor_ContactForm.instance;
    }

    constructor(){
        elementor.hooks.addAction( 'panel/open_editor/widget/opal-template', (panel) => {
            this.onPanelShow(panel);
        } );
    }

    onPanelShow(panel){
        let templateIdControl = panel.content.currentView.collection.findWhere( { name: 'cf_id' } );

        if ( ! templateIdControl || 'cf_id' !== templateIdControl.get( 'name' ) ) {
            return; // No templates
        }

        let templateIdInput = panel.content.currentView.children.findByModelCid( templateIdControl.cid );

        // Order templates by name.
        let $controlOptions = templateIdInput.$el.find( 'option' ),
            $select = templateIdInput.$el.find( 'select' ),
            // Keep the first option ( - select -) without order.
            $optionsSelect = $controlOptions.eq( 0 ),
            currentValue = panel.content.currentView.model.get( 'settings' ).get( 'cf_id' );

        delete $controlOptions[0];

        $controlOptions.sort( function( a, b ) {
            let c = a.text.toLowerCase(),
                d = b.text.toLowerCase();
            if ( c > d ) {
                return 1;
            } else if ( c < d ) {
                return -1;
            }
            return 0;
        } );

        $select.empty().append( $optionsSelect ).append( $controlOptions );

        // Reset value, because the 'selected option' is changed while play with the options.
        $select.val( currentValue );

        // Change Edit link on change template.
        templateIdInput.on( 'input:change', this.onTemplateIdChange ).trigger( 'input:change' );

    }


    onTemplateIdChange(){
        let formID = this.options.elementSettingsModel.attributes.template_id,
            type = this.options.model.attributes.types[ formID ],
            $editButton = this.$el.find( '.elementor-edit-' );

        if ( '0' === formID || ! formID || 'widget' === type ) { // '0' = first option, 'widget' is editable only from Elementor page
            if ( $editButton.length ) {
                $editButton.remove();
            }

            return;
        }

        let editUrl = ElementorConfig.home_url + '?page=wpcf7&post=' + formID;

        if ( $editButton.length ) {
            $editButton.prop( 'href', editUrl );
        } else {
            $editButton = jQuery( '<a />', {
                target: '_blank',
                'class': 'elementor-button elementor-button-default elementor-edit-form',
                href: editUrl,
                html: '<i class="fa fa-pencil" /> Edit Form'
            } );

            this.$el.find( '.elementor-control-input-wrapper' ).after( $editButton );
        }
    }
}

Elementor_ContactForm.getInstance();